import { datadogRum } from '@datadog/browser-rum'
import type { Transport, UserTrack } from '@/core/Transport'

export class DatadogTransportAdapter implements Transport {
  track(event: string, context: Record<string, unknown>) {
    try {
      return datadogRum.addAction(event, context)
    } catch (error) {
      console.error('Error tracking event', error)
    }
  }

  page(context: Record<string, unknown>, extras?: Record<string, unknown>) {
    try {
      datadogRum.setViewContext({
        ...context,
        ...extras,
      } as Record<string, string>)

      return this.track('page_view', {
        page_location: context.location,
        page_path: context.path,
        page_title: context.title,
        ...extras,
      })
    } catch (error) {
      console.error('Error setting view context', error)
    }
  }

  identify(user: UserTrack) {
    try {
      this.track('identify', { user_id: user.userId })
    } catch (error) {
      console.error('Error identifying user', error)
    }
  }
}
